import { render } from "./ImgBlog.vue?vue&type=template&id=5fb5cbf8&scoped=true"
import script from "./ImgBlog.vue?vue&type=script&lang=js"
export * from "./ImgBlog.vue?vue&type=script&lang=js"

import "./ImgBlog.vue?vue&type=style&index=0&id=5fb5cbf8&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb5cbf8"]])

export default __exports__